<template>
    <div>
        <div class="detail" style="width: 70%;margin-left: 15%;padding: 20px 0 20px 0">
            <!-- 需求订单 -->
            <div class="demand">
                <div class="title">需求信息</div>
                <ul>
                    <li>工程名称：<span>{{ info.title }}</span></li>
                    <li>用工需求：<span>{{ info.need }}</span></li>
                    <li>工程简介：<span>{{ info.introduction }}</span></li>
                    <li>工程所需技能：<span>{{ info.ability }}</span></li>
                    <li>工程所需资质：<span>{{ info.qualification }}</span></li>
                </ul>
                <ul>
                    <li>工作地点：<span>{{ info.address }}</span></li>
                    <li>接单说明：<span>{{ info.instruction }}</span></li>
                    <li>计划工程总额（元）：<span>{{ info.price }}</span></li>
                    <li>人数限制：<span>{{ info.number }}</span></li>
                    <li>预计工期（天）：<span>{{ info.days }}</span></li>
                </ul>
                <ul>
                    <li>单价上限（人/天）：<span>{{ info.up }}</span></li>
                    <li>单价下限（人/天）：<span>{{ info.down }}</span></li>
                    <li>状态：<span>{{ formatStatus(info.status) }}</span></li>
                    <li>创建时间：<span>{{ info.createTime }}</span></li>
                    <li>预估服务费：<span>{{ info.fwf }}</span></li>
                </ul>
                <ul>
                    <li>随机码：<span>{{ info.needP }}</span></li>
                    <li>总接单额：<span>{{ accountMoney }}</span></li>
                    <li>总接单人数：<span>{{ person }}</span></li>
                    <li v-if="(info.status || 0 ) > 1">总结算单金额：<span>{{ actually }}</span></li>
                </ul>
            </div>

            <div class="price">
                <div class="title">订单信息</div>
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column type="index" label="序号" width="50"/>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="day" label="计划天数"></el-table-column>
                    <el-table-column prop="money" label="计划单价（元）"></el-table-column>
                    <el-table-column prop="price" label="计划总价（元）"></el-table-column>
                    <el-table-column prop="day1" label="实际天数">
                        <template scope="{row}">
                            {{row.day1 || row.day}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="money1" label="实际单价（元）">
                        <template scope="{row}">
                            {{row.money1 || row.money}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price1" label="实际总价（元）">
                        <template scope="{row}">
                            {{row.price1 || row.price}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="100">
                        <template scope="{row}">
                            <div class="time-line">
                                <div class="count">
                                    {{formatStatusD(row.status) }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" prop="desc" width="180">
                        <template scope="{row}">
                            <div class="btns">
                                <el-button size="mini" type="info" @click="openDialog(row)" v-if="info.status === '1'&&(row.status ==='2'||row.status ==='3')">修改结算单</el-button>
                                <el-button size="mini" type="info" @click="openDialog2(row)">查看</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: flex-end;margin-top: 20px;" v-if="total">
                    <el-pagination
                            background
                            layout="prev, pager, next,total"
                            :total="total"
                            :page-size="query.pageSize"
                            @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                </div>
            </div>
            <div class="info">
                <div style="display: flex;justify-content: center;padding: 20px;">
                    <el-button type="info" size="medium" @click="setEnd" v-if="info.status == 0">结束招工</el-button>
                    <el-button type="info" size="medium" @click="complete" v-if="info.status == 1">确认完工</el-button>
                    <el-button type="info" size="medium" @click="payMoney" v-if="info.status ==='5'">待支付</el-button>
                </div>
            </div>
        </div>

        <!--<router-view :key="id"></router-view>-->

        <el-dialog title="结算单" :visible.sync="dialogVisible" width="40%">
            <div class="title">
                <div class="name">
                    <div class="padding"></div>订单详情
                </div>
            </div>
            <div style="display: flex;flex-wrap: wrap;">
                <div class="item address-box" v-for="(item, index) in formConfig">
                    <p class="tit1">{{item.title}}</p>
                    <div class="address-box1">
                        <template v-if="item.type === 'input'">
                            <el-input class="address_input" v-model="info[item.prop]" :placeholder="item.placeholder" size="medium" disabled>
                                <template slot="prepend" v-if="item.prepend">{{item.prepend}}</template>
                                <template slot="append" v-if="item.append">{{item.append}}</template>
                            </el-input>
                        </template>
                        <template v-else-if="item.type === 'textarea'">
                            <textarea v-model="info[item.prop]" :placeholder="item.placeholder" disabled></textarea>
                        </template>
                    </div>
                </div>
            </div>
            <div class="title">
                <div class="name">
                    <div class="padding"></div>
                    确认信息
                </div>
            </div>
            <!--:rules="rules1"-->
            <el-form :model="form1"  ref="form1" label-width="100px" style="margin: 10px 0px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="单价（元/天）">
                            <el-input v-model="form1.money1"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作天数">
                            <el-input v-model="form1.day1"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addOrUpdate">确 认</el-button>
			</span>
        </el-dialog>

        <el-dialog title="付款详情" :visible.sync="dialogVisible1" width="40%">
            <el-form :model="form2" label-width="100px" style="margin: 10px 0px" disabled>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划天数">
                            <el-input v-model="form2.day"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际天数">
                            <el-input v-model="form2.day1"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划人数">
                            <el-input v-model="form2.number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际人数">
                            <el-input v-model="form2.number1"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划服务费">
                            <el-input v-model="form2.serverPrice"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际服务费">
                            <el-input v-model="form2.serverPrice1"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划劳工费">
                            <el-input v-model="form2.planPrice"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际劳工费">
                            <el-input v-model="form2.price1"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划总额">
                            <el-input v-model="form2.price"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际总额">
                            <el-input v-model="form2.sjPrice"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="uploadCss">
                <el-upload
                        class="avatar-uploader"
                        :action="$uploadFileUrl1"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :on-success="uploadHandle"
                        :file-list="fileList"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="payMoney1">确 认</el-button>
			</span>
        </el-dialog>

        <el-dialog title="查看电工详情" :visible.sync="dialogVisible2" width="600px" append-to-body>
            <el-descriptions title="电工信息" :column="1" >
                <el-descriptions-item label="姓名">{{ruleForm.name}}</el-descriptions-item>
                <el-descriptions-item label="身份证号码">{{ruleForm.idCard}}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{ruleForm.phone}}</el-descriptions-item>
                <el-descriptions-item label="联系地址">{{ruleForm.address}}</el-descriptions-item>
                <el-descriptions-item label="电工简介">{{ruleForm.introduce}}</el-descriptions-item>
                <el-descriptions-item label="报价：（人/天）">{{ruleForm.quoted}}</el-descriptions-item>
                <el-descriptions-item label="电工类型">{{formatStatusT(ruleForm.electricianTypeId)}}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>

    </div>
</template>

<script>
    import api from "../../http/electrician/api.js";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "detail",
        data() {
            return {
                id: '',
                info: {},
                tableData: [],
                query: {
                    pageSize: 10,
                    pageNum: 1
                },
                total: 0,
                accountMoney: '',
                person: '',
                actually: '',
                form1: {
                    money1: '',
                    day1: ''
                },
                rules1: [

                ],
                dialogVisible: false,
                formConfig:[
                    {
                        type: 'input',
                        title: '工程名称',
                        prop: 'title',
                        placeholder: '请输入工程名称',
                    }, {
                        type: 'input',
                        title: '用工需求',
                        prop: 'need',
                        placeholder: '请输入用工需求'
                    }, {
                        type: 'input',
                        title: '工程简介',
                        prop: 'introduction',
                        placeholder: '请输入工程简介'
                    } , {
                        type: 'input',
                        title: '工程所需技能',
                        prop: 'ability',
                        placeholder: '请输入工程所需技能'
                    } , {
                        type: 'input',
                        title: '工程所需资质',
                        prop: 'qualification',
                        placeholder: '请输入工程所需资质'
                    } , {
                        type: 'input',
                        title: '工作地点',
                        prop: 'address',
                        placeholder: '请输入工作地点'
                    } , {
                        type: 'input',
                        title: '接单说明',
                        prop: 'instruction',
                        placeholder: '请输入接单说明'
                    } , {
                        type: 'input',
                        title: '工程总额（元）',
                        prop: 'price',
                        placeholder: '请输入工程总额（元）',
                        prepend: '总价',
                        append: '/￥'
                    } , {
                        type: 'input',
                        title: '人数限制',
                        prop: 'number',
                        placeholder: '请输入人数限制',
                        append: '/人'
                    } , {
                        type: 'input',
                        title: '工期（天）',
                        prop: 'days',
                        placeholder: '请输入工期（天）',
                        prepend: '时长：',
                        append: '/天'
                    } , {
                        type: 'input',
                        title: '单价上限（人/天）',
                        prop: 'up',
                        placeholder: '请输入单价上限（人/天）',
                        append: '/￥'
                    } , {
                        type: 'input',
                        title: '单价下限（人/天）',
                        prop: 'down',
                        placeholder: '请输入单价下限（人/天）',
                        append: '/￥'
                    }
                ],
                order: {},
                dialogVisible1: false,
                form2: {},
                dialogVisible2: false,
                ruleForm: {

                },
                fileList: []
            };
        },
        methods: {
            ...mapActions( ['getElecticianType']),
            getDetail() {
                api.orderDetails(this.id).then(res => {
                    if(res){
                        this.info = res.need;
                        this.accountMoney = res.accountMoney;
                        this.person = res.person;
                        this.actually = res.actually;
                    }
                });
              this.getTable();
            },
            getTable(){
                api.selectBindShareOrder({...this.query, id: this.id}).then(res => {
                    if(res.code === 200){
                        this.total = res.total;
                        this.tableData = res.rows;
                    }
                });
            },
            //结束招工
            setEnd(){
                api.endRecruitment({id: this.info.id, number: this.info.number, price: this.info.price}).then(res => {
                    if(res.code ===200){
                        this.$message.success(res.msg);
                        this.getDetail(this.id);
                    }
                });
            },
            openDialog(row){
                this.dialogVisible = true;
                this.order = row;
                this.form1.money1 = row.money1 || row.money;
                this.form1.day1 = row.day1 || row.day;
            },
            // 修改 结算单
            addOrUpdate(){
                let data = {
                    ...this.form1,
                    id: this.order.accountId,
                    orderId: this.order.id,
                    price2: this.form1.day1 * this.form1.money1,
                    needId: this.order.needId,
                    name: this.order.name,
                    sex: this.order.sex,
                    idCard: this.order.idCard,
                    bankCard: this.order.bankCard,
                    speciality: this.order.speciality,
                    work: this.order.electricianTypeId,
                    address: this.order.address,
                    title: this.info.title,
                    needP: this.order.needP,
                    personId: this.order.personId,
                };
                api.insertShareAccount(data).then(res => {
                    if(res){
                        this.$message.success("修改成功");
                        this.dialogVisible = false;
                        this.getDetail(this.id);
                    }
                });
            },
            // 完工
            complete(){
                api.addsAccount(this.info.id).then(res => {
                    if(res.code ===200){
                        this.$message.success(res.msg);
                        this.getDetail(this.id);
                    }else{
                        this.$message.error(res.msg);
                    }
                });
            },
            // 付款
            payMoney(){
                this.dialogVisible1 = true;
                api.selectCountMeoney(this.id).then(res => {
                    this.form2 = res;
                });
            },
            payMoney1(){
                let aa = "";
                if(this.fileList.length>0){
                    this.fileList.forEach(item =>{
                        aa+= "," + item.url;
                    })
                }
                api.sendMoney({id: this.id, filePath: aa.substring(1)}).then(res => {
                    if(res.code === 200){
                        this.dialogVisible1 = false;
                        this.getDetail(this.id);
                        this.fileList = [];
                    }
                });
            },
            // 格式化
            formatStatus(obj){
                const data = this.needStatus.find(item => item.value === obj);
                if(data){
                    return data.label;
                }
                return "";
            },
            formatStatusD(obj){
                const data = this.orderStatus.find(item => item.value === obj);
                if(data){
                    return data.label;
                }
                return "";
            },
            formatStatusT(obj){
                const data = this.electicianType.find(item => item.id === obj);
                if(data){
                    return data.name;
                }
                return "";
            },
            openDialog2(row){
                this.dialogVisible2 = true;
                this.ruleForm = {};
                api.getInfoById(row.personId).then((res) => {
                    this.ruleForm = res;
                    this.ruleForm.region= [
                        parseInt(res.province),
                        parseInt(res.city),
                        parseInt(res.county),
                    ];
                });
            },
            handleCurrentChange(val) {
                this.query.pageNum = val;
                this.getTable();
            },
            // 上传
            uploadHandle(file) {
                if(file.code == 200){
                    this.fileList.push({name: file.fileName, url: file.fileName});
                }
            },
            handleRemove(file, fileList) {
                this.fileList = fileList;
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            }
        },
        created: function () {
            //生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
            if(this.electicianType.length == 0){
                this.getElecticianType();
            }
        },
        mounted: function () {
            //模板编译/挂载之后
            this.id = this.$route.query.id;
            this.getDetail();
        },
        computed:{
            ...mapGetters(['needStatus', 'orderStatus', 'electicianType'])
        }
    };
</script>

<style lang="less" scoped="scoped">
    .scoreBtn {
        width: 1.38rem;
        background: #686868;
        border-radius: 0.09rem;
        bottom: 0rem;
        text-align: center;
        font-size: 0.14rem;
        color: #ffffff;
        padding: 0.1rem 0;
        line-height: 0.2rem;
    }

    .detail {
        width: 100%;
    }

    .demand,
    .info,
    .price,
    .evaluate {
        width: 100%;
        background: @vue-bg-color;
        /*<!--margin-bottom: @vue-spacing-col-lg;-->*/
        padding: 0px @vue-spacing-row-base;
        box-sizing: border-box;

        .title {
            font-size: 16px;
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid @vue-border-color;
            font-weight: bold;

            span {
                color: orange;
                font-size: @vue-font-size-sm - 2;
            }
        }

    }

    .demand {
        padding-bottom: @vue-spacing-col-base;

        ul,
        .desc {
            width: 100%;
            display: flex;
        }

        ul {
            li {
                width: 20%;
                padding: 10px 10px;
                box-sizing: border-box;
                line-height: 30px;
                color: @vue-text-color-grey;
                font-size: @vue-font-size-sm - 2;

                span {
                    color: @vue-text-color;
                }
            }
        }

        .desc {
            justify-content: space-between;
            font-size: @vue-font-size-sm - 2;

            .key {
                width: 80px;
                line-height: 40px;
                padding: 0px 10px;
                box-sizing: border-box;
                color: @vue-text-color-grey;
            }

            .value {
                width: calc(100% - 80px);
                line-height: 40px;
                background: @vue-bg-color-grey;
                padding: 0px @vue-spacing-row-base;
                box-sizing: border-box;
            }
        }
    }
    .title {
        width: 100%;
        height: 50px;
        border-bottom: 1px solid @vue-border-color;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;

        .name {
            height: 100%;
            display: flex;
            align-items: center;
        }

        .padding {
            width: 4px;
            height: 16px;
            background: #ff5252;
            margin-right: @vue-spacing-row-sm;
        }
    }


    .address-box{
        width: 50%;
        display: flex;
        align-items: center;
        margin: 5px 0px;
        .tit1{
            width: 140px;
            text-align: end;
        }
        .address-box1{
            width: 200px;
        }
    }

    /deep/ .uploadCss {
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }
    }
</style>
